import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SelectBoxModule } from 'app/shared/components/select-box/select-box.module';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { ChartModule } from 'app/shared/helpers/chart/chart.module';
import { ResultsChartViewComponent } from './results-chart-view.component';

@NgModule({
  imports: [CommonModule, SelectBoxModule, ChartModule, BlockModalDragModule],
  declarations: [ResultsChartViewComponent],
  exports: [ResultsChartViewComponent],
})
export class ResultsChartViewModule {}
